@let step1 = form();

<ng-container [formGroup]="step1">
  <div class="form-row">
    <adm-org-typeahead
      [hidden]="service.isEditing()"
      [initialId]="step1.controls.organizationId.value ?? undefined"
      [resetTrigger]="resetOrgTrigger()"
      [disabled]="isPrePopulated()"
      [required]="true"
      [validationControl]="step1.controls.organizationId"
      (clearTypeAhead)="resetOrganization()"
      (itemSelected)="organizationSelected($event ?? undefined)" />
  </div>
  <div class="form-row">
    <adm-dep-typeahead
      [hidden]="service.isEditing()"
      [organizationId]="step1.controls.organizationId.value"
      [departmentId]="step1.controls.departmentId.value"
      [required]="true"
      [validationControl]="step1.controls.departmentId"
      [disabled]="isPrePopulated()"
      (itemSelected)="onDepartmentSelected($event)"
      [resetTrigger]="resetDepTrigger()" />
  </div>

  <div class="form-row">
    <mat-form-field>
      <mat-label>Kategori</mat-label>
      <mat-select formControlName="category" okCustomDropDownArrowDirective>
        @for (category of categories | enumToArray | translateLocationCategoryEnum; track category.value) {
          <mat-option [value]="category.value"> {{ category.label }} </mat-option>
        }
      </mat-select>
      @if (step1.controls.category.invalid && (step1.controls.category.dirty || step1.controls.category.touched)) {
        <mat-error>
          <div>Kategori skal vælges fra listen</div>
        </mat-error>
      }
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
</ng-container>
